import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Stack from "@mui/material/Stack";
import { Snackbar } from "@mui/material";
import { useEffect, useState, useContext } from "react";
import { Controller, useForm, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  FormGroup,
  TextField,
  InputLabel,
  MenuItem,
  InputAdornment,
  OutlinedInput,
  FormControl,
  Button,
  Box,
  Select,
  Typography,
  FormControlLabel,
  FormLabel,
  Divider,
  FormHelperText,
} from "@mui/material";

import {
  labelStyled,
  groupStyled,
  row,
  col,
  formGroupContainer,
  header,
  leftCol,
} from "../../components/400/styles";
import Fade from "@mui/material/Fade";
import { useNavigate, NavLink } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { SettingsOverscanOutlined } from "@mui/icons-material";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
const axios = require("axios");

// const api = axios.create({
//     baseURL: "http://localhost:5000/api/"
// })

const schema = yup.object().shape({
  studPerSec: yup.number().integer().required(),
//   studPerLec: yup.number().integer().required(),
  studPerLab: yup.number().integer().required(),
  studPerTut: yup.number().integer().required(),
  studPerAdv: yup.number().integer().required(),
});

export default function Constants() {
  const api = useAxiosPrivate();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSub = async (data) => {
    console.log(data);
    const result = await api.put("/updateBatchConstant", data);
  };

  const defaultValues = async () => {
    const result = await api.get("/getBatchConstant");
    const value = result.data.filter(
      (c) =>
        c.key === "stud_per_adv" ||
        c.key === "stud_per_lab" ||
        c.key === "stud_per_lec" ||
        c.key === "stud_per_sec" ||
        c.key === "stud_per_tut"
    );
    // console.log(value)
    setValue("studPerSec", value[0].value);
    // setValue("studPerLec", value[2].value);
    setValue("studPerLab", value[1].value);
    setValue("studPerTut", value[3].value);
    setValue("studPerAdv", value[4].value);
  };

  useEffect(() => {
    defaultValues();
  }, [""]);

  return (
    <form width="100px" onSubmit={handleSubmit(onSub)}>
      <Box sx={header}>
        <Typography
          variant="span"
          sx={{
            fontSize: "1.14rem",
            fontWeight: "600",
            lineHeight: "23.2px",
            color: "primary.main",
            mt : 2 , mb :5
          }}
        >
          settings
        </Typography>
      </Box>
      <Box sx={formGroupContainer}>
        <Box sx={leftCol}>
          <FormControl sx={groupStyled}>
            <FormLabel sx={labelStyled}>student per section(lecture group)</FormLabel>
            <TextField
              id="year"
              name="studPerSec"
              type="number"
              {...register("studPerSec")}
              fullWidth
              error={errors.studPerSec ? true : false}
            />
            <FormHelperText>
              {errors.studPerSec && "student per section is required"}
            </FormHelperText>
          </FormControl>

          {/* <FormControl sx={groupStyled}>
            <FormLabel sx={labelStyled}>student per lecture group</FormLabel>
            <TextField
              id="year"
              name="studPerLec"
              type="number"
              {...register("studPerLec")}
              fullWidth
              error={errors.studPerLab ? true : false}
            />
            <FormHelperText>
              {errors.studPerLab && "student per lecture group is required"}
            </FormHelperText>
          </FormControl> */}

          <FormControl sx={groupStyled}>
            <FormLabel sx={labelStyled}>student per lab group</FormLabel>
            <TextField
              id="year"
              name="studPerLab"
              type="number"
              {...register("studPerLab")}
              fullWidth
              error={errors.studPerLab ? true : false}
            />
            <FormHelperText>
              {errors.studPerLab && "student per lab group is required"}
            </FormHelperText>
          </FormControl>

          <FormControl sx={groupStyled}>
            <FormLabel sx={labelStyled}>student per tutorial group</FormLabel>
            <TextField
              id="year"
              name="studPerTut"
              type="number"
              {...register("studPerTut")}
              fullWidth
              error={errors.studPerTut ? true : false}
            />
            <FormHelperText>
              {errors.studPerTut && "student per tutorial group is required"}
            </FormHelperText>
          </FormControl>

          <FormControl sx={groupStyled}>
            <FormLabel sx={labelStyled}>student per advisory(superVision) group</FormLabel>
            <TextField
              id="year"
              name="studPerAdv"
              type="number"
              {...register("studPerAdv")}
              fullWidth
              error={errors.studPerAdv ? true : false}
            />
            <FormHelperText>
              {errors.studPerAdv && "student per advisory is required"}
            </FormHelperText>
          </FormControl>
        </Box>

        <Divider orientation="vertical" flexItem />
      </Box>

      <Box
        sx={{
          display: "flex",
          gap: "1.8rem",
          justifyContent: "flex-end",
          width: "100%",
        }}
      >
        <Button
          variant="outlined"
          sx={{
            backgroundColor: "teritiary.lighter1",
            "&:hover": {
              backgroundColor: "teritiary.main",
            },
          }}
          onClick={() => {
            navigate("/");
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "secondary.lighter1",
            "&:hover": {
              backgroundColor: "secondary.main",
            },
          }}
          type="submit"
          onClick={() => {
            console.log("clicked");
          }}
        >
          Save
        </Button>
      </Box>
    </form>
  );
}
